/**
 * @group Components
 * @summary <blockquote>MoreHorizontalIcon icon component.</blockquote>
 * @example
 * ```tsx
 * <MoreHorizontalIcon />
 * ```
 */
export const MoreHorizontalIcon = ({ size = 16 }: { size?: number }) => {
        return (
          <svg
            height={size}
            strokeLinejoin="round"
            viewBox="0 0 16 16"
            width={size}
            style={{ color: 'currentcolor' }}
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M4 8C4 8.82843 3.32843 9.5 2.5 9.5C1.67157 9.5 1 8.82843 1 8C1 7.17157 1.67157 6.5 2.5 6.5C3.32843 6.5 4 7.17157 4 8ZM9.5 8C9.5 8.82843 8.82843 9.5 8 9.5C7.17157 9.5 6.5 8.82843 6.5 8C6.5 7.17157 7.17157 6.5 8 6.5C8.82843 6.5 9.5 7.17157 9.5 8ZM13.5 9.5C14.3284 9.5 15 8.82843 15 8C15 7.17157 14.3284 6.5 13.5 6.5C12.6716 6.5 12 7.17157 12 8C12 8.82843 12.6716 9.5 13.5 9.5Z"
              fill="currentColor"
            />
          </svg>
        );
      };